import React from 'react'
import { CAlert, CCard, CCardBody, CCol, CContainer, CRow } from '@coreui/react-pro'

const NeedLink: React.FC = () => {
  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={7}>
            <CCard className="p-4">
              <CCardBody>
                <div className="text-center mb-3" style={{ fontSize: 48 }}>🌴</div>
                <h3 className="text-center">Costa Rica 2027 — Trip Planner</h3>
                <CAlert color="info" className="mt-4">
                  You sign in with your <strong>personal link</strong> — check the text
                  message from Paul. Bookmark it when you're in; it's your login for the
                  whole trip.
                </CAlert>
                <ul className="text-body-secondary small mt-3">
                  <li>Lost your link? Text Paul and he'll send a fresh one.</li>
                  <li>Links are personal — don't post them in the group chat.</li>
                </ul>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default NeedLink
